import React from 'react';
import classnames from 'classnames';
import shortid from 'shortid';
import { noop } from 'lodash';

// local dependencies
import { DATA_TYPES } from 'constants/common';
import { getDisplayValue } from 'resolvers/formatValue';
import { textWithPatternMatch } from 'utils/textWithPatternMatch';

/**
 * @desc Data cell view for multi line cells.
 * @example
 * import { multiLine as MultiLineView } from './cellViews/multiLine.view';
 */
export const multiLine = ( props ) => {

    // get proper display value
    const value = getDisplayValue( { type: props.columnType, value: props.value, options: props.options } );

    // dynamic class name
    const widgetClassName = classnames( 'ui-table-cell-view-multi-line', props.className );

    // item class name
    const itemClassName = classnames( 'ui-table-cell-view-multi-line__display-values__items__item', {
        'ui-table-cell-view-multi-line__display-values__items__item--red-text': props.shouldTextBeRed,
        'ui-table-cell-view-multi-line__display-values__items__item--blue-text': props.shouldTextBeBlue
    } );

    return (
        <div className={ widgetClassName }>
            <div className='ui-table-cell-view-multi-line__display-values' onClick={ props.onClick }>
                <div className='ui-table-cell-view-multi-line__display-values__items'>
                    <div
                        className={ itemClassName }
                        dangerouslySetInnerHTML={ { __html: props.isSearchable ? textWithPatternMatch( {
                            value,
                            pattern: props.searchQuery,
                            wildcard: true,
                            type: props.columnType,
                        } ) : value } }
                    />
                </div>
            </div>
        </div>
    );
};

// display name
multiLine.displayName = 'table.cellViews.multiLine';

// default values
multiLine.defaultValues = {
    uniqId: shortid.generate(),
    value: [],
    maxDisplayValues: undefined,
    isSearchable: false,
    searchQuery: '',
    columnType: DATA_TYPES.TEXT,
    isActionable: false,
    onClick: noop,
};
